import React, { useState, useEffect} from 'react';
import Helper from '../pages/Helper';
import axios from 'axios';
import { apiUrl } from '../pages/UrlParam';
import Button from '@mui/material/Button';
import api from '../pages/AxiosFetchData';
import { useNavigate} from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import AxiosFetchData from '../pages/AxiosFetchData';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CatchWrapperAsync } from '../utils/catchwrapper';
 
export const useAddPOHook = (id,id2,id4) =>{
    const [message,setmessage] = useState('');
        const [tipe,settipe] = useState('');
        const [selectedOptionPayment, setSelectedOptionPayment] = useState(null);
        const [selectedOptionPoType, setSelectedOptionPoType] = useState(null);
        const [paymentOption, setPaymentOption] = useState([]);
        const [open, setOpen] = React.useState(false);
        const [rows, setRows] =  useState([]);
        const [initialrows, setInitialRows] =  useState([]);
        const [revRows, setRevRows] =  useState([]);
        const [unitList, setUnitList] = useState([]);
        const [selectedOptionUnit, setSelectedOptionUnit] = useState(null);
        const [qty, setQty] =  useState(0);
        const [hpp, setHpp] =  useState(0);
        const [totalHpp, setTotalHpp] =  useState(0);
        const [totalHpp2, setTotalHpp2] =  useState(0);
        const [price, setPrice] =  useState(0);
        const [totalPrice, setTotalPrice] =  useState(0);
        const [partNo, setPartNo] =  useState('');
        const [descriptions, setDescription] =  useState('');
        const [poId, setPoId] =  useState('');
        const [typeServiceList, setTypeServiceList] =  useState('');
        const [selectedTypeService, setselectedTypeService] =  useState('');
        const [productRows, setProductRows] = useState([]);
        const [product, setProduct] = useState({});
        const [randomId, setRandomId] =  useState('');
        const [customer, setCustomer] =  useState('');
        const [contactPerson, setContactPerson] =  useState('');
        const Navigate = useNavigate();
        const [disc, setDisc] =  useState(0);
        const [discValue, setDiscValue] =  useState(0);
        const [ppn, setPpn] =  useState(0);
        const [pph, setPph] =  useState(0);
        const [comm, setComm] =  useState(0);
        const [total, setTotal] =  useState(0);
        const [totalPpn, setTotalPpn] =  useState(0);
        const [totalPph, setTotalPph] =  useState(0);
        const [grandTotal, setGrandTotal] =  useState(0);
        const [totalDisc, setTotalDisc] =  useState(0);
        const [commValue, setCommValue] =  useState(0);
        const [productId, setProductId] =  useState('');
        const [subject, setSubject] =  useState('');
        const [notes, setNotes] =  useState('');
        const [contactId, setContactId] =  useState('');
        const [customerId, setCustomerId] =  useState('');
        const [product_id, setProduct_id] = useState({});
        const [poCode, setPoCode] =  useState('');
        const [type, setType] =  useState(0);
        const [rev, setRev] =  useState(0);
        const [revTemp, setRevtemp] =  useState(0);
        const [revDefault, setRevDefault] =  useState(0);
        const [anchorEl, setAnchorEl] = React.useState(null);
        const [totalInvoice, setTotalInvoice] = React.useState(null);
        const [value, setValue] = React.useState('one');
        const [role, setRole ]= React.useState('');
        const [user, setUser ]= React.useState('');
        const [poList, setPoList]= React.useState([]);
        const [customerEmail, setCustomerEmail] =  useState('');
        const [customerPhone, setCustomerPhone] =  useState('');
        const [rowsDelegasi, setRowsDelegasi] = useState([]);
        const [confirmDelegasiOpen, setConfirmDelegasiOpen] = useState('');
        const [roleAccess, setRoleAccess] = useState({});
    
        const menuOpen = Boolean(anchorEl);

        const handleClick = (event,data) => {
           setAnchorEl(event.currentTarget);
        };

        const handleMenuClose = () => {
            setAnchorEl(null);
        };
      
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('ReturnUrl');

        const [filterModel2, setFilterModel2] = React.useState({
            items: [],
            quickFilterExcludeHiddenColumns: true,
            quickFilterValues: [''],
          });
    
        const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({id:false});
        
        useEffect(() => {
            GetData();
            GetPaymentTerm();
            GetUnits()
            GetTypeService();
            
            if(id == id2){
                setType(1)
            }else{
                GetRev();
            } 
    
          }, [Navigate]);
    
    async function GetRev(){
        CatchWrapperAsync(async ()=>{
            var response = await api.get(`GetRev/${id2}`).refreshToken(Navigate);
               console.log(response)
            if(response.data){
                  const rowsWithRowNumbers = response.data.map((row, index) => ({
                  ...row,
                  rowNumber: index + 1,
                }));

                setRevRows(rowsWithRowNumbers)
           
            }

          
      },setmessage,settipe)
    }

    async function GetData(){
            CatchWrapperAsync(async ()=>{
                var response = await api.get(`GetSalesQuotation/${id}/${id2}`).refreshToken(Navigate,"additional");
                if(response){
                  setRole(response.decode.role)
                  setRoleAccess(response.roleaccess)
                  setUser(response.decode)
                  if(response.decode.role == "PM" || response.decode.role.toUpperCase() == "SUPERADMIN"){
                     var po = await api.get(`GetPO/${id}`).refreshToken(Navigate);
                     if(po.data.length > 0){
                        setPoList(po.data)
                        setValue(id2)
                     }
                     setType(1)
                  }
              
                   
                    setTotalInvoice(response.data[0].totalpo)
                    setSelectedOptionPoType(response.data[0].quotation_type)
                    setContactPerson(response.data[0].contactname)
                    setCustomer(response.data[0].customername)
                    setCustomerId(response.data[0].customer_id)
                    setContactId(response.data[0].contact_id)
                    setSelectedOptionPayment(response.data[0].payment_term)
                   // setDisc(response.data[0].disc)
                    setDisc(0)
                    setPph(response.data[0].pph)
                    setPpn(response.data[0].tax)
                    setComm((response.data[0].commision / response.data[0].pototal) * 100)
                 
                   // setComm(response.data[0].commision)
                    setPoCode(response.data[0].quotation_id)
                    setValidUntil(new Date(response.data[0].valid_until))
                    setPoDate(new Date(response.data[0].quotation_date))
    
                    setCustomerPhone(response.data[0].contactphone)
                    setCustomerEmail(response.data[0].contactemail)
                   
                    const rowsWithRowNumbers = response.data.map((row, index) => ({
                        ...row,
                        rowNumber: index + 1,
                       
                    }));
             
                   if(id2 != 0){
                   
                    setSubject(response.data[0].subject)
                    setNotes(response.data[0].notes)
                    setPoDate(new Date(response.data[0].po_date))
                    setValidUntil(new Date(response.data[0].valid_until == "0000-00-00"? null :response.data[0].valid_until))
                    
                    if(response.data[0].id != null){
                      setProductRows(rowsWithRowNumbers)
                      setTotal(response.data[0].pototal);
                      setDisc((response.data[0].disc / response.data[0].pototal) * 100)
                     // setDiscValue(response.data[0].pototal * (response.data[0].disc / 100))
                      setDiscValue(response.data[0].disc)
                      //alert(response.data[0].grand_total)
                      setGrandTotal(response.data[0].grand_total)
                      setTotalPph(response.data[0].pph_value)
                      setTotalPpn(response.data[0].tax_value)
                     // setTotalDisc(response.data[0].pototal * (response.data[0].disc / 100))
                      setTotalDisc(response.data[0].disc)
                      setTotalHpp2(response.data[0].hpptotal)
                      setRev(response.data[0].rev)
                      setRevtemp(response.data[0].rev)
                      setRevDefault(response.data[0].rev_default)
                      setSelectedOptionPayment(response.data[0].payment_term)
                     // setCommValue(response.data[0].pototal * (response.data[0].commision / response.data[0].total))
                     // setCommValue(response.data[0].pototal * (response.data[0].commision / response.data[0].total))
                      setCommValue(response.data[0].commision)
                    }else{
                      setmessage("Items still empty")
                      settipe('error')
                    }
                   
                   
                   //alert(response.data[0].pototal * (response.data[0].commision / response.data[0].total))
                    //console.log(response.data[0].payment_term)
                   }
                  
                }
             
            },setmessage,settipe)
        }

    const handleClickOpen = async () => {
            var response; 
            CatchWrapperAsync(async ()=>{
                setProductId('')
                setRandomId('')
                setQty(0);
                setTotalHpp(0);
                setTotalPrice(0);
                setPrice(0)
                setHpp(0)
                setSelectedOptionUnit(null);
                setPartNo('')
                setDescription('')
                setselectedTypeService(null)
                setOpen(true);
                response = await api.get(`GetSalesQuotation/${id}/${id}`).refreshToken(Navigate);
                
                if(response)
                {
                    const rowsWithRowNumbers = response.data.map((row, index) => ({
                        ...row,
                        rowNumber: index + 1, 
                        
                        }));
                    
                    setInitialRows(response.data)
                    setRows(rowsWithRowNumbers.filter((item)=>item.parent_id == null));
                }
            },setmessage,settipe)
        };

    const handleClose = () => {
          setOpen(false);
        };
    
        const [poType, setPoType] = useState([{
            value : 1,
            label : "Project"
        },
        {
            value : 2,
            label : "Retail"
        }]);
    
        const [validUntil,setValidUntil] = useState(new Date());
        const [poDate,setPoDate] = useState(new Date());
    
    function GetPaymentTerm(){
            axios.get(`${apiUrl}/api/GetPaymentTerm`)
            .then((response) => {
              const transformedOptions = response.data.map((item) => ({
                label: `${item.id} - ${item.name}`,
                value: item.id,
              }));
              setPaymentOption(transformedOptions);
              //return transformedOptions;
            })
            .catch((error) => {
              console.error('Error fetching category data:', error);
            });
             
        }

    function GetUnits(){
            axios.get(`${apiUrl}/api/GetUnits`)
            .then((response) => {
              const transformedOptions = response.data.map((item) => ({
                label: `${item.id} - ${item.name}`,
                value: item.id,
              }));
              setUnitList(transformedOptions);
              //return transformedOptions;
            })
            .catch((error) => {
              console.error('Error fetching category data:', error);
            });
             
        }

        function GetTypeService(){
            var data =[{
               value : 1,
               label : "Item"
            },
            {
                value : 2,
               label : "Service"
            }
           ]
           setTypeServiceList(data)
       }

       function handleTotal(data){
        // alert(comm)
           var total = 0;
           var totalPpn = 0
           var totalPph = 0
           var totalhpp = 0;
           var newdata = data.filter((item)=> item.parent_id == null)
           
           for(let x = 0;x < newdata.length;x++){
             total += newdata[x].total ;
             totalhpp +=  newdata[x].hpp_total ;
           }
          // console.log(data.filter((item) => item.product_type == 2))
           var listPpn = data.filter((item) => item.product_type == 1)
           for(let x = 0;x < listPpn.length;x++){
             totalPpn += listPpn[x].total ;
           }
   
           var listPph = data.filter((item) => item.product_type == 2)
           for(let x = 0;x < listPph.length;x++){
             totalPph += listPph[x].total ;
           }
       
           setTotal(total);
           setTotalHpp2(totalhpp)
           
           setCommValue(total * (comm /100))
            
           setDiscValue(total * (disc / 100))
           setTotalDisc(total * (disc / 100))
         
           var totalppn = (totalPpn - (totalPpn * (disc / 100))) * (ppn /100);
           var totalpph = (totalPph - (totalPph * (disc / 100))) * (pph /100) +  (totalPph - (totalPph * (disc / 100))) * (ppn /100);
           
            
           setTotalPpn(totalppn)
           setTotalPph(totalpph)
          // setGrandTotal((total - totalDisc) + totalppn + totalpph)
           setGrandTotal((total - (total * (disc / 100))) + totalppn +  totalpph)
           //setGrandTotal((total) + totalppn +  totalpph)
       }

       function handleDisc(value){
       
        setDisc(value)
        setDiscValue((value / 100) * total);
        setTotalDisc((value / 100) * total);
       // setCommValue((total - (total * (value / 100))) * ( comm /100))
        setCommValue(total * ( comm /100))
        
        var totalppn = (total - (total * (value / 100))) * (ppn /100);
        var totalpph = (total - (total * (value / 100))) * (pph /100);
 
        setTotalPpn(totalppn)
        setTotalPph(totalpph)
        //setGrandTotal((total - ((value / 100) * total)) + totalppn + totalpph)
        setGrandTotal((total - ((value / 100) * total)) + totalppn)
    }

    async function handleDefault(){
      CatchWrapperAsync(async ()=>{
          const response = await api.get(`SetDefault/${id2}`).refreshToken(Navigate);
          if(response){
            
            setmessage(response.data);
            await GetRev();
            setAnchorEl(null)
          }
      },setmessage,settipe)
    }

    function handleDelete(id){
        
            const rowsWithRowNumbers = productRows.filter((row) => row.id !== id).filter((row) => row.parent_id !== id).map((row, index) => ({
                ...row,
                rowNumber: index + 1,
               
            }));
    
           setProductRows(rowsWithRowNumbers)
           handleTotal(rowsWithRowNumbers);
    }

    function handleEdit(row){
            var data ={
                row : row
            }
          
           // console.log(data)
    
            handleClickOpen();
            setProductId(row.id)
          // alert(row.id)
            setProduct(row.id)
           // alert(row.id)
            handleQty(row.qty)
            handleRowClick(data)
          
           // handleClickOpen();
            setOpen(true);
    }
 
    
    const columns= [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            { field: 'part_no', headerName: 'Part No.', width: 250 },
            { field: 'descriptions', headerName: 'Descriptions', width: 250 },
    ];

    const revColumns= [
            { field: 'rowNumber', headerName: 'No.', width: 50 },
            {
                field: 'action',
                headerName: '',
                width: 150,
               
                renderCell: (params) => (
                  <>
                   <Button
                       onClick={() => Navigate(`/AddPO/${id}/${params.row.po_id}?ReturnUrl=${myParam}`)} // Pass the project ID to the edit function
                    //  className="btn btn-primary mr-2"
                     >
                     <ModeEditIcon  sx={{ fontSize: 15 }}/>
                    </Button>
                   &nbsp; 
                   <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button" title="Delete"  onClick={() => handleDeleteRev(params.row.po_id,params.row.rev_default)} >
                              <DeleteForeverIcon sx={{fontSize:15}} />
                    </ConfirmationButton>
                   
                  </>
                  
                ),
            },
            {
                field: 'isDefault',
                headerName: 'Default',
                width: 100,
                renderCell: (params) => (
                  <>
                  {params.row.rev_default == 1 && (
                      
                      <CheckCircleIcon  sx={{ fontSize: 20 }}/>
                    
                  )}
    
                  
                  </>
                  
                ),
            },
            { field: 'rev', headerName: 'Rev#', width: 50 },
            { field: 'po_date', headerName: 'PO Date', width: 100 },
            { field: 'createdAt', headerName: 'Created Date', width: 200 },
            { field: 'total', headerName: 'Total', width: 200, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
            { field: 'disc', headerName: 'Discount', width: 100 },
            { field: 'tax_value', headerName: 'PPN', width: 200 , valueGetter:({ value }) => value && Helper.formatAsCurrency(value)},
            { field: 'grand_total', headerName: 'Grand Total', width: 200, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
            { field: 'hpp_total', headerName: 'HPP Total', width: 200, valueGetter:({ value }) => value && Helper.formatAsCurrency(value) },
             
          ];
    
    const columnsDelegasi = [
              { field: 'rowNumber', headerName: 'No.', width: 80 },
              { field: 'nama_client', headerName: 'ID', width: 200 },
               
             {
                field: 'actions',
                headerName: 'Actions',
                width: 170,
                renderCell: (params) => (
                  <>
                  
                    <ConfirmationButton classname='btn btn-primary mr-2' text="Do you want choose this data?" type="button" onClick={() => handleDelegasi(params.row.id)}>
                         Pilih
                     </ConfirmationButton>
                  </>
                  
                ),
            
            
                
              },
            
    ];

    const handleRowClick = (
                params, // GridRowParams
                event, // MuiEvent<React.MouseEvent<HTMLElement>>
                details, // GridCallbackDetails
              ) => {
           
               setHpp(params.row.hpp)
               setPrice(params.row.price)
               setSelectedOptionUnit({value : params.row.unit_id, label : params.row.unit_id + ' - ' + params.row.unitname})
               setTotalHpp(params.row.hpp * (event == undefined ? params.row.qty : qty))
               setTotalPrice(params.row.price * (event == undefined ? params.row.qty : qty))
               setPartNo(params.row.part_no)
               setDescription(params.row.descriptions)
               setPoId(id)
               setselectedTypeService(params.row.product_type)
               setDescription(params.row.descriptions)
               setRandomId(params.row.id)
               setselectedTypeService(params.row.product_type)
               setProduct_id(params.row.product_id)
               
              };

              const handleQty = (value)=>{
                  setQty(value)
                  setTotalHpp(value * hpp);
                  setTotalPrice(value * price)
               }

               const handleSubmit = (e) =>{
                e.preventDefault(); 
               
                if(!randomId || randomId ==''){
                    setmessage("Please select an item");
                    settipe('error')
                    return;
                }
               
                if(productRows.filter(row => row.id != productId).filter(row => row.id == randomId).length > 0){
                    setmessage("The Item already exists in the list");
                    settipe('error')
                    return;
                }
         
                var data = {
                    // rowNumber : list.filter((row) => row.id !== randomId).length + 1,
                    rowNumber:0,
                    id: randomId,
                    part_no : partNo,
                    descriptions : descriptions,
                    qty : parseInt(qty),
                    unit_id : selectedOptionUnit.value,
                    price : price,
                    hpp : hpp,
                    unitname : selectedOptionUnit.label.split('-')[1],
                    hpp_total : totalHpp,
                    total : totalPrice,
                    product_id : product_id,
                    product_type : selectedTypeService,
                    descriptions : descriptions,
                }
              
                let subDetailList = initialrows.filter((row) => row.parent_id == (Array.isArray(product) ? product[0] : product))
           
                var newData = [...productRows.filter((row) => row.id !== productId), data]
            
                if(subDetailList.length > 0){
                 for(var i = 0 ; i < subDetailList.length; i++){
                    subDetailList[i].qty = qty * subDetailList[i].qty
                    subDetailList[i].total = (subDetailList[i].qty) * subDetailList[i].price
                    subDetailList[i].hpp_total = ((subDetailList[i].qty) * subDetailList[i].hpp) + subDetailList[i].other_cost
                 } 
        
                 newData = [...newData.filter((item) => item.parent_id == null),...subDetailList]
               
                }
               console.log(newData)
                const rowsWithRowNumbers = newData.map((row, index) => ({
                    ...row,
                    rowNumber: index + 1,
                }));
        
                setProductRows(rowsWithRowNumbers)
                handleTotal(newData);
                handleClose();
    }

    const handleSave = async (e) => {
          e.preventDefault(); 
                
          CatchWrapperAsync(async ()=>{
                  var data = {
                    project_id : id,
                    total_all : totalInvoice
                  }
                  var inv =  await AxiosFetchData.post("CheckInvoice",data).refreshToken(Navigate,"additional")
                   
                  
                  if(productRows.length == 0){
                    setmessage("Item list is still empty")
                    settipe('error')
                    return;
                  }
        
                  if(!inv.data && id2==0){
                      setmessage("Invoice is already 100%, can't add more Work / PO")
                      settipe('error')
                      return;
                  }
        
         
                    var data = {
                        po_kode : poCode,
                        po_date : poDate,
                        po_type : selectedOptionPoType,
                        subject : subject,
                        total : total,
                        tax : ppn,
                        tax_value : totalPpn,
                        pph : pph,
                        pph_value : totalPph,
                        grand_total :grandTotal,
                        hpp_total : totalHpp2,
                        payment_term : typeof(selectedOptionPayment.value) == 'undefined' ? selectedOptionPayment: selectedOptionPayment.value,
                        valid_until : validUntil,
                        notes :notes,
                        //disc : disc,
                        disc :discValue == null ? 0 : discValue ,
                        project_id :id,
                        customer_id : customerId,
                        contact_id :contactId,
                        isDelete : 0,
                        items: productRows,
                        rev : id2 == 0 ? 0 : rev,
                        rev_default : id2 == 0 ? 1 : (rev == revTemp ? revDefault  : 0),
                        commision : commValue
                    }
                   
                    const response = await api.post(`UpdatePO?id=${id2}`, data).refreshToken(Navigate);
                    
                    setmessage(response.data);
                    await GetRev();
                    setTimeout(() => {
                      const myParam = urlParams.get('ReturnUrl');
                      Navigate('/' + myParam)
                    }, 2000);
          },setmessage,settipe)
                 
    }

    const handleRev = async (type) => {
                const response = await AxiosFetchData.get(`GetLastRev/${id}/${id2}`).refreshToken(Navigate,"additional");
                
                if(response){
                    if(type=='add'){
                        setRev(parseInt(response.data) + 1)
                    }else{
                        setRev(revTemp)
                    }
                    
                    setAnchorEl(null);
                }
    }

    async function handleDeleteRev(id, revDefault){
      CatchWrapperAsync(async () => { 
          const response = await api.delete(`DeleteRev/${id}/${revDefault}`).refreshToken(Navigate)
          if(response){
            setmessage(response.data.msg)
            if(response.data.value == 0){
                await GetRev();
                return;
            }

            setTimeout(() => {
                Navigate(`/AddPO/${id}/${response.data.value}?ReturnUrl=${myParam}`)
            }, 300);
            
          }
      },setmessage,settipe)
    }
    
    const handleChangeTab = (event, newValue) => {
          setValue(newValue);
          Navigate(`/AddPO/${id}/${newValue}/${id4}${window.location.search}`)
    };

    const handleDelegation = async () => {
            setConfirmDelegasiOpen(true);
            CatchWrapperAsync(async ()=>{
              const response = await AxiosFetchData.get("GetDelegasi").refreshToken(Navigate,"additional",true);
              if(response){
                  setRowsDelegasi(response.data);
              }
            },setmessage,settipe)
    };

    async function handleDelegasi(employeeId){
            var data = {
                id_resource:employeeId,
                id_project :  id,
                nama_project :subject,
                id_client : customerId,
                assigned_by : user.userID,
                alias_project :subject,
                id_status : 1
            }
      
            AddProject(data)
            setConfirmDelegasiOpen(false);
    }

    async function AddProject(data){
        CatchWrapperAsync(async () => {
            const response = await AxiosFetchData.post(`AddProject`, data).refreshToken(Navigate,"additional");
            if(response){
              setmessage(response.data)
            }
        },setmessage,settipe)
          
    }

    return {message,setmessage,tipe,settipe,handleSave,poCode,value,handleChangeTab,type,open,handleClick,anchorEl,menuOpen,handleMenuClose,handleRev,revTemp,rev,handleDefault,handleDelete,poType,setSelectedOptionPoType,selectedOptionPoType,poDate,setPoDate,setValidUntil,validUntil,customer,setCustomer,contactPerson,setContactPerson,customerPhone,setCustomerPhone,customerEmail,setCustomerEmail,paymentOption,setSelectedOptionPayment,selectedOptionPayment,subject,role,setSubject,notes,setNotes,roleAccess,handleClickOpen,productRows,handleEdit,disc,handleDisc,discValue,setDiscValue
            ,totalHpp2,comm,setComm,commValue,setCommValue,ppn,setPpn,pph,setPph,total,setTotal,totalDisc,setTotalDisc,totalPpn,setTotalPpn,totalPph,setTotalPph,grandTotal,setGrandTotal,revRows,revColumns,handleClose,handleSubmit,rows,columns,handleRowClick,product,setProduct,unitList,setSelectedOptionUnit,selectedOptionUnit,price,setPrice,totalPrice,setTotalPrice,qty,handleQty,hpp,setHpp,totalHpp,setTotalHpp,typeServiceList,setselectedTypeService,descriptions,setDescription,confirmDelegasiOpen,setConfirmDelegasiOpen,columnsDelegasi,rowsDelegasi,filterModel2,setFilterModel2,columnVisibilityModel,setColumnVisibilityModel,
            poList,handleDelegation,setTotalHpp2,selectedTypeService
    }
}